// --- Modules
import Node, { payload } from './Node';

class CloudService extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Cloud Service'
    });
  }
};

export default {
  create: (opts) => {
    let item = new CloudService(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
